
import { React, classNames, Suspense, Fragment} from '@api'
import {Drawer as MaterialDrawer } from '@material-ui/core'
import {DrawerProps} from '@material-ui/core/Drawer/Drawer'
import {LoadingIndicator} from '@modules'
import {removeUndefinedsNested} from '@utils'
import { DrawerBody, DrawerFooter, DrawerHeader } from 'centric-ui-components'
import { observable} from 'mobx';
import {observer} from 'mobx-react';
import * as css from './Drawer.css'

export type DrawerTitleLocation = 'inline' | 'topBar'

interface MyProps extends Partial<DrawerProps> {
  /** Object containing label and component to render */
  content?: {titleComponent?: React.ReactNode, bodyComponent?: React.ReactNode, footerComponent?: React.ReactNode}
  /** Boolean for showing/hiding drawer */
  open?: boolean
  /** Drawer alignment options */
  align?: 'left' | 'right'
  /** Handler for closing drawer */
  onClose?: (e) => void
  /** Variant of drawer (permanent, persistent) */
  variant?: 'permanent' | 'persistent' | 'temporary'

  id?: string
  titleLocation: DrawerTitleLocation
  drawerHeaderClassName?: string
  disableEscapeKeyDown?: boolean
}

@observer
export class Drawer extends React.Component<MyProps & {classes?: any}> {
  static defaultProps = {
    align: 'left',
    titleLocation: 'inline',
  }

  @observable mounted = false

  componentDidMount(): void {
    this.mounted = true
  }

  get drawerHeader() {
    const {props: {content, variant, titleLocation, classes, drawerHeaderClassName}} = this
    return content && content.titleComponent && <DrawerHeader className={drawerHeaderClassName} variant={variant} titleLocation={titleLocation}>
      {content.titleComponent}
    </DrawerHeader>
  }

  render() {
    const {drawerHeader, props: {id, content, open, onClose, classes, align, variant, children, className, titleLocation, drawerHeaderClassName, disableEscapeKeyDown, ...props}} = this

    //const duration = 0;
    return (
      <MaterialDrawer
        className={classNames(className, css.root)}
        data-open={open}
        data-variant={variant}
        data-align={align}
        data-type='Drawer'
        data-title-location={titleLocation}
        id={id}
        open={open}
        anchor={align}
        onClose={onClose}
        variant={variant}
        PaperProps={{}}
        ModalProps={{disableAutoFocus: true, disableEnforceFocus: true, disableEscapeKeyDown}}
        //transitionDuration={{enter: duration, exit: duration }}
        classes={{
          paperAnchorLeft: classNames( css.paperAnchorLeft),
          paperAnchorRight: classNames(css.paperAnchorRight),
          paper: classNames(css.paper, classes?.drawerPaper)
        }}
        {...removeUndefinedsNested(props)}>
        <Suspense fallback={<LoadingIndicator />}>
                {children ? children : <Fragment>
                  {titleLocation == 'inline' && drawerHeader}
                    <DrawerBody>
                        {content.bodyComponent}
                    </DrawerBody>
                  {content.footerComponent && <DrawerFooter >
                        {content.footerComponent}
                    </DrawerFooter> }
                </Fragment>}
        </Suspense>
      </MaterialDrawer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/Drawer.tsx